import React, { FunctionComponent, useState } from 'react';
import { Button, TextArea, Modal } from '@scuf/common';
import { HAS_SCRIPT, REQUIRED } from '../../../../constants/constants';
import './Acknowledge.scss';
import '../../NewCardDesign/CommonStyle.scss';
import { getCurrentRole } from 'src/slices/onBoardingSlice';
import { useSelector } from 'react-redux';
interface IAcknowledgeProps {
  role_name?: string;
  onClose: Function;
  opportunityId: any;
  kpiId: number;
  anomalyId?: string;
  orguserId?: string;
  sendUserResponse: Function;
}
const Acknowledge: FunctionComponent<IAcknowledgeProps> = (props) => {
  const currentRole = useSelector(getCurrentRole);
  const [comment, setComment] = useState('');
  const [error, setError] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = () => {
    const { error, message } = textValidation(comment);
    if (error) {
      setError(error);
      setErrorMessage(message);
      return;
    }
    setLoading(true);

    const data = {
      current_role: currentRole,
      user_response: 'accept',
      kpi_id: props.kpiId,
      remarks: comment,
      reason: '',
      orguser_id: props.orguserId,
      anomaly_id: props.anomalyId,
    };
    props.sendUserResponse(data, []);
  };

  const textValidation: (value: string) => {
    error: boolean;
    message: string;
  } = (value) => {
    let inValidCharacter = /[<>()&#]/;
    switch (true) {
      case typeof value === 'string' && value.trim() === '': {
        return { error: true, message: REQUIRED };
      }
      case inValidCharacter.test(value): {
        return { error: true, message: HAS_SCRIPT };
      }
      default: {
        return { error: false, message: '' };
      }
    }
  };

  const onTextAreaChange = (value: string) => {
    const { error, message } = textValidation(value);
    setErrorMessage(message);
    setError(error);
    setComment(value);
  };

  return (
    <>
      <Modal.Content>
        <TextArea
          className='acknowledge-textarea required'
          fluid
          rows={2}
          label={'Please describe planned actions'}
          placeholder='Please add your additional comments here'
          error={errorMessage}
          onChange={(newNoteText) => onTextAreaChange(newNoteText)}
          value={comment.trimStart()}
        />
      </Modal.Content>

      <Modal.Footer className='pop-footer'>
        <Button
          className='button--secondary button-space'
          size='small'
          type='secondary'
          disabled={loading}
          onClick={() => props.onClose()}
          content='Cancel'
        />
        <Button
          data-testid='note-add__comment'
          className={`button--primary  button-space`}
          size='small'
          type='primary'
          content={'Submit'}
          loading={loading}
          disabled={error || loading}
          onClick={onSubmit}
        />
      </Modal.Footer>
    </>
  );
};
export default Acknowledge;
